import {
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchEntityName: '',
    searchType: 'ALL', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'TOTAL', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date())
  },
  searchInfo: {
    searchEntityName: '',
    searchType: 'ALL', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'TOTAL', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date())
    // startDt: null,
    // endDt: null
  },
  searchedForm: {
    searchEntityName: '',
    searchType: 'ALL', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'TOTAL', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date())
    // startDt: null,
    // endDt: null
  },
  END_STATE: null
}

const getters = {

}

const actions = {
  async downloadProjStatistic({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    // let searchType = state.searchedForm.searchType
    // let startDt = new Date(0).getTime()
    // let endDt = new Date(0).getTime()
    // if (state.searchedForm.searchType === 'MONTH') {
    //   startDt = Utils.getMonthFirstDay(state.searchedForm.searchMonth)
    //   endDt = Utils.getMonthLastDay(state.searchedForm.searchMonth)
    // } else if (state.searchedForm.searchType === 'DT_SCOPE') {
    //   startDt = state.searchedForm.searchDtScope[0]
    //   endDt = state.searchedForm.searchDtScope[1]
    // }
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_STATISTIC, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  async updateSearchInfo(state, searchInfo) {
    state.searchInfo = {...searchInfo}
  },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchEntityName(state, value) {
    state.searchInfo.searchEntityName = value
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },

  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/entryStatisticManage.js